import { useTranslation } from "react-i18next";

export const GeneralReportOrganizationBillingComponent = ({ athletes }) => {
  const { t } = useTranslation("dashboard");
  return (
    <section role="table-wrapper" data-borders-inside data-scrollable>
      <table role="report-table">
        <thead className="labels">
          <tr>
            <th className="name">{t("coachBillingReport.athlete")}</th>
            <th className="email">{t("coachBillingReport.email")}</th>
            <th className="name">{t("organizationBillingReport.assignedCoach")}</th>
            <th className="amount">{t("coachBillingReport.totalDays")}</th>
          </tr>
        </thead>
        <tbody>
          {athletes.length > 0 &&
            athletes.map((athlete) => {
              const {
                athleteName = "",
                athleteEmail = "",
                amount: athleteAmount,
                athleteId,
                coachName = "",
              } = athlete;
              return (
                <tr className="report" key={String(athleteId)}>
                  <td className="name">{athleteName}</td>
                  <td className="email">{athleteEmail}</td>
                  <td className="name">{coachName}</td>
                  <td className="amount">{Number(athleteAmount).toFixed(0)}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </section>
  );
};
